import { render, staticRenderFns } from "./newUservideo.vue?vue&type=template&id=21861cbe&scoped=true&"
import script from "./newUservideo.vue?vue&type=script&lang=js&"
export * from "./newUservideo.vue?vue&type=script&lang=js&"
import style0 from "./newUservideo.vue?vue&type=style&index=0&id=21861cbe&prod&scoped=true&lang=scss&"
import style1 from "./newUservideo.vue?vue&type=style&index=1&id=21861cbe&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21861cbe",
  null
  
)

export default component.exports